// extracted by mini-css-extract-plugin
export default {"errorAccurate":"accurate_errorAccurate__PmW+i"};